<div
  class="sidebar-area bg-white active"
  [ngClass]="{'active': isSidebarToggled}"
  [class.component-dark-theme]="themeService.isDark()"
  [class.dark-sidebar]="themeService.isSidebarDark()"
  [class.right-sidebar]="themeService.isRightSidebar()"
  [class.hide-sidebar]="themeService.isHideSidebar()"
  [class.card-borderd-theme]="themeService.isCardBorder()"
  [class.rtl-enabled]="themeService.isRTLEnabled()"
>
  <div class="logo bg-white">
    <a routerLink="/" class="d-flex align-items-center">
      <!-- <img src="images/logo-icon.svg" alt="logo-icon" /> -->
      <span class="material-symbols-outlined">
        sports_tennis
      </span>
      <span class="fw-semibold">mitorneo.app</span>
    </a>
  </div>
  <div
    (click)="toggle()"
    class="burger-menu"
    [ngClass]="{'active': isSidebarToggled}"
  >
    <span class="top-bar"></span>
    <span class="middle-bar"></span>
    <span class="bottom-bar"></span>
  </div>
  <ng-scrollbar visibility="hover">
    <div class="sidebar-inner">
      <div class="sidebar-menu">
        <mat-accordion>
          <span class="sub-title text-body">
            PRINCIPAL
          </span>
          <!-- <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <i class="material-symbols-outlined">
                  dashboard
                </i>
                <span class="title">
                  Dashboard
                </span>
                <span class="daxa-badge">
                  5
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sidebar-sub-menu">
              <li class="sidemenu-item">
                <a
                  routerLink="/"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}"
                  class="sidemenu-link"
                >
                  E-Commerce
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/crm"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}"
                  class="sidemenu-link"
                >
                  CRM
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/project-management"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}"
                  class="sidemenu-link"
                >
                  Project Management
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/lms"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}"
                  class="sidemenu-link"
                >
                  LMS
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/help-desk"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}"
                  class="sidemenu-link"
                >
                  Help Desk <span class="daxa-badge">Hot</span>
                </a>
              </li>
            </ul>
          </mat-expansion-panel> -->
          <a
            routerLink="/tournaments"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}"
            class="sidebar-menu-link"
          >
            <i class="material-symbols-outlined">
              trophy
            </i>
            <span class="title">
              Torneos
            </span>
          </a>
          <a
            routerLink="/rankings"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}"
            class="sidebar-menu-link"
          >
            <i class="material-symbols-outlined">
              stadium
            </i>
            <span class="title">
              Clasificación general
            </span>
          </a>

          <span class="sub-title text-body">
            ADMINISTRACIÓN
          </span>
          <!-- <a
            routerLink="/admin/locations"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}"
            class="sidebar-menu-link"
          >
            <i class="material-symbols-outlined">
              location_city
            </i>
            <span class="title">
              Sedes
            </span>
          </a>
          <a
            routerLink="/admin/courts"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}"
            class="sidebar-menu-link"
          >
            <i class="material-symbols-outlined">
              width_normal
            </i>
            <span class="title">
              Canchas
            </span>
          </a>
          <a
            routerLink="/admin/events"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}"
            class="sidebar-menu-link"
          >
            <i class="material-symbols-outlined">
              stadium
            </i>
            <span class="title">
              Eventos
            </span>
          </a> -->
          <a
            routerLink="/admin/tournaments"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}"
            class="sidebar-menu-link"
          >
            <i class="material-symbols-outlined">
              trophy
            </i>
            <span class="title">
              Torneos
            </span>
          </a>
          <a
            routerLink="/admin/players"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}"
            class="sidebar-menu-link"
          >
            <i class="material-symbols-outlined">
              group
            </i>
            <span class="title">
              Jugadores
            </span>
          </a>

          <!-- <span class="sub-title text-body">
            ADMINISTRACIÓN
          </span>
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <i class="material-symbols-outlined">
                  settings
                </i>
                <span class="title">
                  Configuración
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sidebar-sub-menu">
              <li class="sidemenu-item">
                <a
                  routerLink="/admin/locations"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}"
                  class="sidemenu-link"
                >
                  Sedes
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/admin/courts"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}"
                  class="sidemenu-link"
                >
                  Canchas
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/admin/events"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}"
                  class="sidemenu-link"
                >
                  Eventos
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/admin/tournaments"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}"
                  class="sidemenu-link"
                >
                  Torneos
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/admin/players"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}"
                  class="sidemenu-link"
                >
                  Jugadores
                </a>
              </li>
            </ul>
          </mat-expansion-panel> -->
        </mat-accordion>
      </div>
    </div>
  </ng-scrollbar>
</div>
